var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.971986 1.12057L1.26915 1.12057C1.46609 1.12057 1.62575 1.28024 1.62575 1.47717L1.62575 4.28912C2.9094 2.10262 5.28802 0.636632 8.00871 0.645131C12.0617 0.65782 15.3612 3.97365 15.3549 8.02663C15.3485 12.0914 12.0514 15.3846 7.98514 15.3846C6.08547 15.3846 4.35369 14.6659 3.04687 13.4855C2.89493 13.3482 2.88777 13.1122 3.03255 12.9674L3.24261 12.7574C3.37643 12.6235 3.59176 12.6173 3.73241 12.7439C4.8584 13.7573 6.34879 14.3742 7.98514 14.3742C11.4841 14.3742 14.3445 11.5413 14.3445 8.01486C14.3445 4.51589 11.5116 1.65547 7.98514 1.65547C5.52275 1.65547 3.38686 3.05445 2.33037 5.10262L5.2512 5.10262C5.44813 5.10262 5.6078 5.26228 5.6078 5.45922L5.6078 5.75638C5.6078 5.95332 5.44813 6.11299 5.2512 6.11299L0.971986 6.11299C0.775053 6.11299 0.615385 5.95332 0.615385 5.75638L0.615385 1.47717C0.615385 1.28024 0.775053 1.12057 0.971986 1.12057ZM10.5303 10.4883L10.6701 10.2961C10.786 10.1368 10.7508 9.91376 10.5915 9.79792L8.46061 8.24822L8.46061 3.85451C8.46061 3.65758 8.30094 3.49791 8.10401 3.49791L7.86627 3.49791C7.66934 3.49791 7.50967 3.65758 7.50967 3.85451L7.50967 8.73243L10.0322 10.567C10.1914 10.6828 10.4145 10.6476 10.5303 10.4883L10.5303 10.4883Z",
    id: "Icon-Color",
    fillRule: "evenodd",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.9368d826a699ecfb299b81b443f4d85b.svg";
export { ForwardRef as ReactComponent };